import { TimelineOppositeContent } from '@mui/lab';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import EmptyPlaceholder from '../../../../../components/Table/EmptyPlaceholder';
import { EMPTY_STOCK_PATH } from '../../../../../utils/images.constants';
import { GetOrderPaymentHistoryDTO } from '../../../order.types';
import OrderPaymentHistoryItem from './OrderPaymentHistoryItem';

interface OrderPaymentHistoryModalContentProps {
  isLoading: boolean;
  payments: GetOrderPaymentHistoryDTO[];
}

const OrderPaymentHistoryModalContent = ({
  isLoading,
  payments,
}: OrderPaymentHistoryModalContentProps) => {
  if (isLoading) {
    return null;
  }

  if (!payments.length) {
    return (
      <Timeline>
        <EmptyPlaceholder width={200} height={200} src={EMPTY_STOCK_PATH} message="" />
      </Timeline>
    );
  }

  return (
    <Timeline sx={{ padding: 0 }}>
      <>
        <TimelineItem>
          <TimelineOppositeContent />
          <TimelineSeparator>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent />
        </TimelineItem>
        {payments.map((item, index) => (
          <OrderPaymentHistoryItem
            {...item}
            key={item.orderGatewayPaymentHistoryId}
            isLast={payments.length - 1 === index}
          />
        ))}
      </>
    </Timeline>
  );
};

export default OrderPaymentHistoryModalContent;
